<template>
  <div class="page">
    <!-- <Tabstop :topListindex="6"></Tabstop> -->

    <div class="page-img-swiper">
      <div class="swiper-container swiper-1">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="../assets/img/news/banner.png" alt="" srcset="" />
          </div>
        </div>
        <!-- 如果需要分页器 注释下方html结构 -->
        <div class="swiper-pagination"></div>
      </div>
    </div>

    <div class="commom-title-box">
      <div class="title-top">动态新闻</div>
      <div class="title-background">Brand News</div>
    </div>


    <div class="page-new-box">

      <div class="news-list" v-for="(item,index) in dataList" :key="index" @click="onOpeninfo(item)">

        <div class="new-list-left">
          <img :src="item.homePicture" alt="">
        </div>

        <div class="new-list-right">
          <div class="new-list-title">
            {{item.newsTitle}}
          </div>
          <div class="new-list-desc">
            
            {{item.homeIntroduction}}
          </div>
          <div class="new-list-time">
            发布时间：{{item.createTime.substring(0,11)}}
          </div>
        </div>

      </div>


    </div>

    <div style="text-align:center;margin-bottom:50px;margin-top:50px;">
        <el-button @click="onLoadMore" style="background: #3A7DD8;" type="primary" round>查看更多 ></el-button>
    </div>



    <PageBottom></PageBottom>
  </div>
</template>
    
    <script>

export default {
  name: "news",
  data() {
    return {
      shopShow: true,
      isZsMore: false,
      tabsindex: 0,
      dataList:[],
      total:0,
      queryParams: {
        pageNum: 1,
        pageSize: 5,
      },
    };
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    new Swiper(".swiper-1", {
      loop: true, // 循环模式选项 用于轮播图的切换
      speed: 500, // 轮播图 消失到出现 切换的时间
      autoplay: {
        delay: 3000, // 轮播图 在多长时间后显示下一张图片；
        disableOnInteraction: false,
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

   
  },
  created() {
    this.loadData(1)
  },

  methods: {

    async loadData(type){
      if(type){
        this.dataList= []

      }
      const list = await this.$get({
        api: "/system/news/webList",
        data: this.queryParams,
      });

      this.dataList = this.dataList.concat(list.rows)
      this.total = list.total
    },
    onLoadMore(){
      if(this.total <= this.dataList.length){
        this.$message('暂无更多');
        return
      }

      this.queryParams.pageNum+=1
      this.loadData()

    },
    onOpeninfo(item){

      this.$router.push({
          path: '/newsinfo',
          query:{
            newsId: item.newsId,
          }
        })

    }
    
  },
};
</script>
    
    <style lang="scss" scoped>


.page-img-swiper {
  width: 100%;
  /* height: 600px; */
}

.swiper-container {
  width: 100%;
  /* height: 600px; */
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
}



.page-new-box{
  width: calc(100% - 560px);
  margin: 0 auto;
  .news-list{
    width: 100%;
    height: 294px;
    display: flex;
    margin-bottom: 40px;
    cursor: pointer;

    .new-list-left{
      width: 495px;
      height: 294px;
      img{
        width: 495px;
        height: 294px;
      }
    }


    .new-list-right{
      flex: 1;
      height: 294px;
      padding-top: 30px;
      padding-left: 50px;

      .new-list-title{
        font-size: 28px;
        font-family: Noto Sans S Chinese;
        font-weight: 600;
        color: #333333;
        height: 110px;

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;//设置多少行   

      }

      .new-list-desc{
        height: 64px;
        font-size: 16px;
        font-family: Noto Sans S Chinese;
        font-weight: 500;
        color: #333333;
        margin-bottom: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;//设置多少行   
      }

      .new-list-time{
        font-size: 16px;
        font-family: Noto Sans S Chinese;
        font-weight: 500;
        color: #666666;
      }
    }
  }



}

.animate__animated {
  --animate-duration: 2s;
}
</style>
    